<div class="center-content">
	<div nz-row class="landolt-block">
		<div *ngFor="let element of landoltElements, let i = index" nz-col class="landolt twenty-span">
			<div class="landolt-button" (click)="toggleSelected(i, $event)">
				<img *ngIf="element.value === 0" src="assets/images/icons/landolt_C_slim_u.svg" alt="U"/>
				<img *ngIf="element.value === 1" src="assets/images/icons/landolt_C_slim_r.svg" alt="C"/>
				<img *ngIf="element.value === 2" src="assets/images/icons/landolt_C_slim_d.svg" alt="&cap;"/>
				<img *ngIf="element.value === 3" src="assets/images/icons/landolt_C_slim_l.svg" alt="&#390;"/>
			</div>
		</div>
	</div>
</div>

<div class="extrabuttons buttonrow replaceButtonrow">
	<div class="left-buttons"></div>
	<div class="right-buttons">
		<!--Vorwärts für Seiten einzelner Fragen-->
		<button nz-button nzType="primary" class="big-button right-one" (touchstart)="dispatchVitaReact($event)" (mousedown)="dispatchVitaReact($event)">
			{{ 'actions.stop' | translate }}
		</button>
	</div>
</div>
